import request from '@utils/request'

export function fetchLogList(params) {
  return request({
    url: '/admin/log',
    method: 'get',
    params,
  })
}

export function fetchLogVars(seq) {
  return request({
    url: `/admin/log/${seq}/var`,
    method: 'get',
  })
}
